import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";

export function useSegmentationDelete() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function deleteSegmentation(segmentationId) {
        if (!segmentationId) {
            const validationMessage = "Não foi possível identificar a segmentação.";

            setError(validationMessage);

            return {
                ok: false,
                reason: "validation",
                error: validationMessage
            };
        }

        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const requestOptions = {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/segmentacoes/${encodeURIComponent(segmentationId)}`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível excluir a segmentação."
                );
            }

            return {
                ok: true
            };
        } catch (requestError) {
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        deleteSegmentation
    };
}